import React from "react";
import { connect } from "react-redux";
import { Layout } from "antd";
import BookingDetailCard from "../../cards/BookingCard";
import CommonCard from "../../cards/Card";
import Retail from "../../../src/assets/images/women-retail-img.jpg";
import Booking from "../../../src/assets/images/automotive-img.jpg";
import FoodScanner from "../../../src/assets/images/food-Scanner.jpg";
import wellbeing from "../../../src/assets/images/wellbeing.jpg";
import Slider from "react-slick";
import { ReactComponent as SliderLeftIcon } from "../../assets/images/new-images/arrow_left.svg";
import { ReactComponent as SliderRightIcon } from "../../assets/images/new-images/arrow_right.svg";
import ResetPasswordModal from "../../modals/ResetPasswordModal";

import HomeBannerSilder from './component/slider';

import {
  getAdvertisementListAction,
  getPageListingAction,
  setCurrentLocation,
  loadingAction,

  setLatLong,
  newInClassified,
  newInBookings,
  closeLoginModel,
  openLoginModel,
  updateBannerHeight,
} from "../../store/actions/index";
import { langs } from "../../config/localization";
import { getAddress } from "../common";
import NoContentFound from "../common/NoContentFound";
import "../../style/newUI/pages/mainLandingPage.less";
import BottomAdvBanner from './component/bottomAdv';
const { Content } = Layout;
class WelcomePage extends React.Component {
  constructor(props) {
    super(props);
    this.bannerDiv = React.createRef();
  }

  /**
   * @method componentDidMount
   * @description called after render the component
   */
  componentDidMount() {
    this.props.loadingAction(true);

    this.props.getAdvertisementListAction({ page_id: "home-page" }, (res) => { });
    this.props.getPageListingAction({ page_id: "home-page" });
    this.props.loadingAction(false);
    const mapObj = window.navigator;
    let lat, long;
    let me = this.props;
    if (mapObj.geolocation) {
      mapObj.geolocation.getCurrentPosition(function (position) {
        lat = position.coords.latitude;
        long = position.coords.longitude;
        const data = { lat: lat, long: long };
        me.setLatLong(data);
        getAddress(lat, long, (res) => {
          if (res) {
            me.setCurrentLocation(res);
          }
        });
      });
    }

    let bannerElement = document.getElementsByClassName("main-landingpage-banner")[0];
    const height = window.pageYOffset + bannerElement.getBoundingClientRect().top;

    this.props.updateBannerHeight(height);
  }

  /**
   * @method render
   * @description render component
   */
  render() {
    const { topImages, bottomImages, pageListing } = this.props;
    let retail = [], bookings = [], classified = [];
    if (pageListing) {
      retail = pageListing.retail;
      bookings = pageListing.booking;
      classified = pageListing.classified;
    }

    const slickSettingsProductCategory = {
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      nextArrow: (
        <button>
          <SliderRightIcon />
        </button>
      ),
      prevArrow: (
        <button>
          <SliderLeftIcon />
        </button>
      ),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 415,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    };


    return (
      <div className='App home-page-main-block'>
        <Layout>
          <Layout>
            <Layout>
              <div className='main-landingpage-banner main' ref={(ref) => (this.bannerDiv.current = ref)}>
                <HomeBannerSilder topImages={topImages} />
              </div>

              <Layout className='categorySection main'>
                <div className='container'>
                  <div className='title-wrap'>
                    <h2>Explore Categories</h2>
                  </div>
                  <div className='relatedCategoryInner'>
                    <div className='relatedCateoryWrap'>
                      <div
                        className='relatedCateoryBlock'
                        onClick={() => {
                          this.props.history.push(`/retail-listing/women-1-163`);
                        }}
                      >
                        <div className='relatedCategoryImg'>
                          <img src={Retail} alt='Pantry' />
                          <div className='relatedCategoryText'>Women Retail</div>
                        </div>
                      </div>
                    </div>
                    <div className='relatedCateoryWrap'>
                      <div
                        className='relatedCateoryBlock'
                        onClick={() => {
                          this.props.history.push(`/classified-listing/automotive-1-30`);
                        }}
                      >
                        <div className='relatedCategoryImg'>
                          <img src={Booking} alt='Health' />
                          <div className='relatedCategoryText'>Automotive</div>
                        </div>
                      </div>
                    </div>
                    <div className='relatedCateoryWrap'>
                      <div className='relatedCateoryBlock twoImgRow'>
                        <div
                          className='relatedCategoryImg'
                          onClick={() => {
                            this.props.history.push(`/bookings-tourism/55`);
                          }}
                        >
                          <img src={FoodScanner} alt='Electronics' />
                          <div className='relatedCategoryText'>Tourism</div>
                        </div>
                        <div
                          className='relatedCategoryImg'
                          onClick={() => {
                            this.props.history.push(`/booking-listing/wellbeing-1-3`);
                          }}
                        >
                          <img src={wellbeing} alt='Electronics' />
                          <div className='relatedCategoryText'>Wellbeing</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Layout>
              <Content className='site-layout'>
                <div className='productListingSection retail'>
                  <div className='container'>
                    <div className='productListingWrap'>
                      <div className='panelTitle'>
                        <div className='panelTitleLeft'>
                          <h3>{"New in Retail"}</h3>
                        </div>
                      </div>
                      <div className='productListing'>

                        {retail && retail.length ? (
                          <>
                            <Slider {...slickSettingsProductCategory}>
                              {retail.map((data, i) => {
                                return <CommonCard data={data} key={i} retail={true} col={6} page={"home"} theme={langs.sellerType.retail} />;
                              })}
                            </Slider>
                          </>
                        ) : (
                          <NoContentFound />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='productListingSection classified'>
                  <div className='container'>
                    <div className='productListingWrap'>
                      <div className='panelTitle'>
                        <div className='panelTitleLeft'>
                          <h3>{"New in Classifieds"}</h3>
                        </div>
                      </div>
                      <div className='productListing'>
                        {classified && classified.length ? (
                          <>
                            <Slider {...slickSettingsProductCategory}>
                              {classified.map((data, i) => {
                                return <CommonCard data={data} key={i} retail={false} col={6} page={"home"} theme={langs.modules.classified} />;
                              })}
                            </Slider>
                          </>
                        ) : (
                          <NoContentFound />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='productListingSection booking'>
                  <div className='container'>
                    <div className='productListingWrap'>
                      <div className='panelTitle'>
                        <div className='panelTitleLeft'>
                          <h3>{"New in Bookings"}</h3>
                        </div>
                      </div>
                      <div className='productListing'>
                        {bookings && bookings.length ? (
                          <>
                            <Slider {...slickSettingsProductCategory}>
                              {bookings.map((data, i) => {
                                return <BookingDetailCard data={data} key={i} col={6} page={"home"} theme={langs.modules.booking} />;
                              })}
                            </Slider>
                          </>
                        ) : (
                          <NoContentFound />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <BottomAdvBanner bottomImages={bottomImages} />
                <ResetPasswordModal token={this.props.match?.params?.token} />
              </Content>
            </Layout>
          </Layout>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { pageData: { advertisementList, pageListing }, general: { categoryList } } = store;
  const banners = advertisementList;
  const topImages = banners && Array.isArray(banners) ? banners.filter((el) => el.banner_position === langs.key.top) : [];
  const bottomImages = banners && Array.isArray(banners) ? banners.filter((el) => el.banner_position === langs.key.bottom) : [];

  let retailList = [],
    classifiedList = [],
    bookingList = [];

  classifiedList = categoryList && Array.isArray(categoryList.classified) ? categoryList.classified : [];
  bookingList = categoryList && Array.isArray(categoryList.booking) ? categoryList.booking : [];
  retailList = categoryList && Array.isArray(categoryList.retail) ? categoryList.retail : [];

  return {
    pageListing: pageListing ? pageListing.data : { retail: [], booking: [], classified: [] },
    retailList,
    classifiedList,
    bookingList, topImages, bottomImages
  };
};
export default connect(mapStateToProps, {
  getAdvertisementListAction,
  getPageListingAction,
  setCurrentLocation,
  loadingAction,
  newInClassified,
  newInBookings,
  setLatLong,
  closeLoginModel,
  openLoginModel,
  updateBannerHeight,
})(WelcomePage);
